'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var getScrollbarSize = require('./getScrollbarSize-fd98d1d5.js');
require('./enums-de2d9d36.js');

var setOverflow = function (initialPadding) {
    document.body.style.overflow = 'hidden';
    var isScrollVisible = window.innerHeight < document.body.clientHeight;
    var scrollbarWidth = isScrollVisible ? getScrollbarSize.getScrollbarSize() : 0;
    document.body.style.paddingRight = isScrollVisible ? initialPadding + scrollbarWidth + "px" : initialPadding + "px";
};
var removeOverflow = function (initialPadding) {
    document.body.style.overflow = '';
    document.body.style.paddingRight = initialPadding + "px";
};

var marginIndent = 8;
var getDivPosition = function (_a) {
    var isAnchoredToTop = _a.isAnchoredToTop, ref = _a.ref, divRef = _a.divRef;
    if (!ref.current || !divRef.current)
        return { left: 0, top: 0, openDown: true };
    var windowHeight = window.innerHeight;
    var _b = ref.current.getBoundingClientRect(), top = _b.top, left = _b.left;
    var dropHeight = divRef.current.getBoundingClientRect().height;
    var containerHeight = ref.current.offsetHeight;
    var bottomOffset = windowHeight - top - containerHeight;
    if (!isAnchoredToTop && bottomOffset < dropHeight) {
        return {
            left: left,
            top: windowHeight - bottomOffset - containerHeight - dropHeight - marginIndent,
            openDown: false,
        };
    }
    return {
        left: left,
        top: top + containerHeight + marginIndent,
        openDown: true,
    };
};

var useAbsolutePositionRefDetails = function (_a) {
    var isActive = _a.isActive, isPortal = _a.isPortal, _b = _a.isAnchoredToTop, isAnchoredToTop = _b === void 0 ? false : _b, ref = _a.ref, divRef = _a.divRef;
    var _c = tslib_es6.__read(React.useState({
        containerWidth: 0,
        left: 0,
        top: 0,
        openDown: true,
    }), 2), position = _c[0], setPosition = _c[1];
    var _d = tslib_es6.__read(React.useState(0), 2), initialPadding = _d[0], setInitialPadding = _d[1];
    var setOverflowCallaback = React.useCallback(function () { return setOverflow(initialPadding); }, [initialPadding]);
    var removeOverflowCallback = React.useCallback(function () { return removeOverflow(initialPadding); }, [initialPadding]);
    var getPositionCallback = React.useCallback(function () { return getDivPosition({ isAnchoredToTop: isAnchoredToTop, ref: ref, divRef: divRef }); }, [isAnchoredToTop, ref, divRef]);
    React.useEffect(function () {
        if (isActive && isPortal && ref.current) {
            var containerWidth = ref.current.offsetWidth;
            setOverflowCallaback();
            setPosition(tslib_es6.__assign({ containerWidth: containerWidth }, getPositionCallback()));
        }
    }, [isActive, isPortal, ref, setOverflowCallaback, getPositionCallback]);
    React.useEffect(function () {
        if (!isActive && isPortal && document.body.style.overflow === 'hidden') {
            removeOverflowCallback();
        }
    }, [isActive, isPortal, removeOverflowCallback]);
    React.useEffect(function () {
        setInitialPadding(Number(document.body.style.paddingRight.replace('px', '')));
    }, []);
    return position;
};

exports.useAbsolutePositionRefDetails = useAbsolutePositionRefDetails;
